<template>
    <div class="row permissions-created-groups mt-4">
        <overview-permission-group v-if="viewingPermissionGroup"
            :viewingPermissionGroup="viewingPermissionGroup"
            @updatePermissionViewingGroup="updatePermissionViewingGroup"
            :permissionsGroupsList="permissionsGroupsList"
            @getPermissionsGroups="$emit('getPermissionsGroups', ...arguments)"
            :allPermissionsByGroup="allPermissionsByGroup"></overview-permission-group>

        <div class="col-sm-12 p-lr-0-sm" v-else>
            <div class="row multisteps-form">
                <div class="col-sm-12 mb-4 p-lr-0-sm" v-if="Object.keys(permissionsGroupsList).length == 0">
                    <div class="card pl-5 pr-5 pb-5 pt-4 dis-flex flex-c flex-column w-full">
                        <div class="row">
                            <div class="col-sm-12 p-lr-0-sm dis-flex flex-column flex-m flex-c">
                                <p class="cl-txt-dark font-p mt-3 mb-4 text-center">You have not created a permission group yet</p>
                                <button class="btn button-create-atrb-btn mt-2 mb-2" type="button" title="Create Category"
                                    @click="$emit('setSelectedMenu', 'createPermGroup')">Create Group</button>
                                <small class="m-b--35">Click the button to Create Group</small>
                            </div>
                        </div>
                    </div>
                </div>
                
                <template v-else>
                    <div class="col-lg-4 col-md-6 col-xl-4 col-xxl-3 col-sm-12 col-12 mb-4 p-lr-0-sm"
                        v-for="thisPermGroup in permissionsGroupsList" :key="thisPermGroup.group_id">
                        <div class="card">
                            <div class="card-body p-3">
                                <div class="col-sm-12 dis-flex flex-sb p-0 mb-3">
                                    <div class="dis-flex flex-m">
                                        <div class="sidebar-cat-icon dis-flex flex-m flex-c">
                                            <div class="uim-svg fs-15">
                                                <svg viewBox="0 0 24 24" width="1em">
                                                    <path class="uim-tertiary" d="M12.979,15.50488a4.43353,4.43353,0,0,1-2.92627-1.09961,1.84838,1.84838,0,0,1-.23584-.2041.99994.99994,0,0,1,1.40137-1.42676.55055.55055,0,0,1,.11914.09668,2.45734,2.45734,0,0,0,3.38916-.09277l4.54785-4.54785a2.47832,2.47832,0,0,0-3.50488-3.50488L14.041,6.4541A.99989.99989,0,0,1,12.627,5.04l1.72852-1.72852a4.47811,4.47811,0,0,1,6.333,6.333l-4.54786,4.54785A4.4623,4.4623,0,0,1,12.979,15.50488Z"></path>
                                                    <path class="uim-primary" d="M6.478,21.99805a4.47608,4.47608,0,0,1-3.16651-7.64258L7.85938,9.80762a4.4558,4.4558,0,0,1,6.08789-.21289,1.84838,1.84838,0,0,1,.23584.2041.99994.99994,0,0,1-1.40137,1.42676.55055.55055,0,0,1-.11914-.09668,2.45636,2.45636,0,0,0-3.38916.09277L4.72559,15.76953a2.47832,2.47832,0,0,0,3.50488,3.50488L9.959,17.5459A.99989.99989,0,0,1,11.373,18.96L9.64453,20.68848A4.4638,4.4638,0,0,1,6.478,21.99805Z"></path>
                                                </svg>
                                            </div>
                                        </div>
                                        <label class="m-0">{{ thisPermGroup.group_name }}</label>
                                    </div>
                                    <div class="btn small-form-btn bar-code fs-10 pointer mt-0" @click="viewingPermissionGroup = `${thisPermGroup.group_id}`" title="Overview Permissions"><i class="uis uis-search fs-11"></i></div>
                                </div>
                                <div class="col-sm-12 p-0">
                                    <div class="form-control bor-dash text-center">
                                        <p v-if="thisPermGroup.group_description && thisPermGroup.group_description.length > 0">{{ thisPermGroup.group_description }}</p>
                                        <p v-else>No group description</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
    
</template>

<script>
import overviewPermissionGroupVue from './overviewPermissionGroup.vue';

export default {
    components: {
        overviewPermissionGroup: overviewPermissionGroupVue
    },
    emits: ['getPermissionsGroups'],
    props: {
        permissionsGroupsList: {
            type: Object,
            required: true
        },
        allPermissionsByGroup: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            viewingPermissionGroup: false,
        }
    },
    methods: {
        updatePermissionViewingGroup(newGroupId) {
            this.viewingPermissionGroup = newGroupId;
        }
    }
}
</script>

<style>

</style>